import qz, { ClearQueueOptions, CreatePrinterInput, PrintData } from "qz-tray"

import { showErrorMessage } from "./ui"
const certificate = `-----BEGIN CERTIFICATE-----
MIIECTCCAvGgAwIBAgIUKHB3Aj8rjjCKHhiuFiMencIJilgwDQYJKoZIhvcNAQEN
BQAwgZMxCzAJBgNVBAYTAlJVMQ8wDQYDVQQIDAZtb3Njb3cxDzANBgNVBAcMBm1v
c2NvdzESMBAGA1UECgwJc2VsbGVyY3JtMRkwFwYDVQQLDBBzZWxsZXJjcm1zZWN0
aW9uMQ8wDQYDVQQDDAZzZWxsZXIxIjAgBgkqhkiG9w0BCQEWE3NlbGxlcmNybUBn
bWFpbC5jb20wHhcNMjYwOTIxMTM1NjQ2WhcNMzYwOTE4MTM1NjQ2WjCBkzELMAkG
A1UEBhMCUlUxDzANBgNVBAgMBm1vc2NvdzEPMA0GA1UEBwwGbW9zY293MRIwEAYD
VQQKDAlzZWxsZXJjcm0xGTAXBgNVBAsMEHNlbGxlcmNybXNlY3Rpb24xDzANBgNV
BAMMBnNlbGxlcjEiMCAGCSqGSIb3DQEJARYTc2VsbGVyY3JtQGdtYWlsLmNvbTCC
ASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBALEjQVHRgPzAQkSlbTrGPvfQ
vYGehUkKnQRtGnnta1bhP7QADHBylA7Dhf1eQgIu96THX6UymDfHtvUtv7fU9pig
oF8NjLIlrLLdTjj+6WzEfu3b/WuoAThyz6328fkt36oGVsRYDgiEaCfhlZVfeW+2
8yzLPLGxFmVmwAe/7XtX0NhkxLkJQLdV0DLPOFLgAm+p2FQ8judxDRYA4/iEoYyq
qyZQEftuh6umzNEnM4oS5Ie0QUBvXSVK6SCKhItyt7mIW4yFCAUAvGByVYKlVFZm
Kndfknxz8/Vs4uZRCqcTavrvK8PZUOujBv2MCRORNfkwTI9Kkj9/cr+cMADIl6sC
AwEAAaNTMFEwHQYDVR0OBBYEFHdfX2xrmCl8Mmske/0AXgFUpFkvMB8GA1UdIwQY
MBaAFHdfX2xrmCl8Mmske/0AXgFUpFkvMA8GA1UdEwEB/wQFMAMBAf8wDQYJKoZI
hvcNAQENBQADggEBADqxJVi5LXJS/D9AzhOdaOTkbIAXplrHRoCH+jSADgqSziTP
g771Vx9jvcmBfKM49feS7EcOkKcnosSB7+xg/dRwqjitTslz9MoZM1D9j/5d5TsD
tPtTJrgB+Wtgab+NZyiBUW5hHZ8hXXwfOtTiWko6cyRBNW3zCMvSuXDpAh/7A2zz
ua7JVT2zwDxtqw1Ah8D5aG3IsF7Z2qN64Im4BkLWQistTbUHL3UztRYkw66QYtrK
Yctm+hHnTNaB3z74zlTDCLlBqmfzI3k/3o6ZWqAPu2mDaHKYewQ+zBuKWgNaYMWN
aJqvJutojDc2sBKQG4SbTCMK6DD9qVjI/sE+ji8=
-----END CERTIFICATE-----
`
const privateKeyPem = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCxI0FR0YD8wEJE
pW06xj730L2BnoVJCp0EbRp57WtW4T+0AAxwcpQOw4X9XkICLvekx1+lMpg3x7b1
Lb+31PaYoKBfDYyyJayy3U44/ulsxH7t2/1rqAE4cs+t9vH5Ld+qBlbEWA4IhGgn
4ZWVX3lvtvMsyzyxsRZlZsAHv+17V9DYZMS5CUC3VdAyzzhS4AJvqdhUPI7ncQ0W
AOP4hKGMqqsmUBH7boerpszRJzOKEuSHtEFAb10lSukgioSLcre5iFuMhQgFALxg
clWCpVRWZip3X5J8c/P1bOLmUQqnE2r67yvD2VDrowb9jAkTkTX5MEyPSpI/f3K/
nDAAyJerAgMBAAECggEABRzK4FUnH2RfJUMPBYC+RYHBTnHoT+TeBkgt2PIIxI+o
uoW71i0AZ/KttdPYHN8FJ7zXXlm4+fcqKSZiX6hmW55bMpMeCfA7bUgk31FAJHMB
ZNUSGd7V9i6eHtu/PR1dVLdtHqqZ8RX9OZVxr0d7pkVF/Hd7L3e4eUG/bhnUfVhN
kvQo9n37WLwEpjKc/k/GJvu347hs0QHvfut9rkPe5iYQkw1jslc/m8onfeK1h9Ik
t4mPIW8kiihAcg17K1tsbyrN27ngc2FRcnM9ZA+1xCgc0F0TCEo62gjQgFtJOnH7
jOQL9nzNfYok5iQi8srE/e10FM0Zoz3uE5N4RMwjDQKBgQD2YLwlNN4c4giB4TYf
OWqLlb0aNXuh+sxHrnRrgqR05OWNICFUaYIxvHagkfUCytvuWAMT4n+qE3MO+Tae
Fcc28jwndUf6b12J16UFnaZ/7BX4GbT0vR0sV8zGWY8RNYl4+I3GO6tK7mAaYUOS
d9ZcgMw2JGI09k6AKKzvazjjZwKBgQC4DkNUpsGG8TNnU+5WfMOPyX+J4uPFad5t
Lkz7O/E0kfwajpzOy4TOP50V16HKoIk+ozyxQkocmJrMgrGYQPEHkTI23HfV2zwX
Bgk4+xw47My3NSWFZ3dgyZbV8hcX3T4nfJTYtCFN4J5J4/Enx/UTcBMm08X+5/BH
UCTvv6pjHQKBgQDRvTIN/n6jWeziHEYFuMwx/gwYtrUEBMxIrYPgTjwQYxfj1xlo
kdVK3+Sg9v/8G5O0yGn+UJBbyejmM1PCqkmIRhjdgmL/GDUp9lE+gaHPPrzJE6FP
w3qFWE00AePgQ5I/UGDpA7zjsiBP9MMgejIbV24BHWIZMiFLytTFkKLCOwKBgDVh
NZfUcSYwyAa8qc/9iT4nY0zbN9HmXXLuzbbDcLYdbK9LEyFKly619loCWtMIciVv
dEe4gQQAIk0Tzmvo0b6vFpAgqsSkO641uvECqvG7g7fSuxoQoue4L33HI3lxWfhb
wlODEnGipmWprSQrcuF7TKKjIrZGEEKudLfvr3vlAoGBALJID1qP+zmDQJr4F/6t
viGsRWCI7oIsHw4hEkp9dNO8tWngEt4+wFfzHOa1/OJvoVEnPuwprWae+um9KO1y
5GojokR1LB0Zhm1c4N2ovFjCxVs6j7XZ24ktZEjAkRf8wCQzqwF/fkLILrBtLzds
MGzfw3UfPuuUUD18Zv43kgVp
-----END PRIVATE KEY-----
`
function pemToBinary(pem: string): Uint8Array {
  const pemContent = pem.replace(
    /-----BEGIN [\w\s]+-----|-----END [\w\s]+-----|\s+/g,
    ""
  )
  if (!/^[A-Za-z0-9+/=]+$/.test(pemContent)) {
    throw new Error("Invalid PEM format")
  }
  return Uint8Array.from(atob(pemContent), (c) => c.charCodeAt(0))
}

async function importPrivateKey(pemKey: string) {
  const binaryDer = pemToBinary(pemKey)
  return window.crypto.subtle.importKey(
    "pkcs8",
    binaryDer.buffer as ArrayBuffer,
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: { name: "SHA-512" },
    },
    true,
    ["sign"]
  )
}

async function signData(privateKey: CryptoKey, toSign: string) {
  const encoded = new TextEncoder().encode(toSign)
  const signature = await window.crypto.subtle.sign(
    { name: "RSASSA-PKCS1-v1_5" },
    privateKey,
    encoded
  )
  return signature
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const byteArray = new Uint8Array(buffer)
  let binaryString = ""
  for (let i = 0; i < byteArray.length; i++) {
    binaryString += String.fromCharCode(byteArray[i])
  }
  return btoa(binaryString)
}

const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const base64String = (reader.result as string).split(",")[1]
      resolve(base64String)
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

export const printWithQZTray = async (pdfBlob: any, withRefresh = true) => {
  const blob = new Blob([pdfBlob], { type: "application/pdf" })
  const base64String = await blobToBase64(blob)

  try {
    const isActive = qz.websocket.isActive()
    if (!isActive) {
      qz.security.setCertificatePromise((resolve) => {
        resolve(certificate)
      })

      const privateKey = await importPrivateKey(privateKeyPem)
      qz.security.setSignatureAlgorithm("SHA512")
      qz.security.setSignaturePromise((toSign) => {
        return async (resolve, reject) => {
          try {
            const signature = await signData(privateKey, toSign)
            const base64Signature = arrayBufferToBase64(signature)
            resolve(base64Signature)
          } catch (err: any) {
            console.error("Error signing data:", err)
            reject(err)
          }
        }
      })

      await qz.websocket.connect()
    }

    const printers = await qz.printers.find()
    if (Array.isArray(printers) && printers.length === 0) {
      showErrorMessage("Проверьте подключение к принтеру.")
      await qz.websocket.disconnect()
      return withRefresh ? "refresh" : null
    }

    let printerFound = false
    for (const printer of printers) {
      await qz.printers.clearQueue(printer as ClearQueueOptions)
      if (printer.includes("Xprinter XP-420B")) {
        printerFound = true
        const config = qz.configs.create(printer as CreatePrinterInput)
        const data = [
          {
            type: "pixel",
            format: "pdf",
            data: base64String,
            flavor: "base64",
          },
        ] as PrintData[]

        await qz.print(config, data).catch(console.error)
      }
    }

    if (!printerFound) {
      showErrorMessage("Не удалось найти принтер Xprinter XP-420B.")
    }
  } catch (err) {
    showErrorMessage("Проверьте подключение к принтеру.")
    console.error("QZ Tray connection failed:", err)
    return withRefresh ? "refresh" : null
  }
}
